import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

export const cookieConsentConfig: NgcCookieConsentConfig = {
    cookie: { domain: '' },
    position: 'bottom-right',
    palette: {
        popup: {
            background: 'var(--twc-dark-gray)',
        },
        button: {
            background: 'var(--twc-topcon-blue)',
        },
    },
    content: {
        href: 'https://global.topcon.com/terms/#cookie',
    },
    theme: 'edgeless',
    type: 'opt-out',
    enabled: false,
};
